import isEmailDonationSupported from '../../utils/featureChecks/isEmailDonationSupported';
import TxpStatus from 'txp-data/lib/schema/TxpStatus';
import TxpEntitiesState from 'txp-data/lib/schema/innerSchema/TxpEntitiesState';

export interface ErrorCardDetails {
    showError: boolean;
    teeTriggeredError: boolean;
}

/**
 * Check whether we need to show error card along with request for donation
 */
export default function showErrorAndRequestDonation(txpStatus: TxpStatus): ErrorCardDetails {
    let errorCardDetails: ErrorCardDetails = {
        showError: false,
        teeTriggeredError: false,
    };
    if (txpStatus && isEmailDonationSupported()) {
        if (txpStatus.isEmailDonationRequested) {
            errorCardDetails = {
                showError: true,
                teeTriggeredError: true,
            };
        } else if (txpStatus.state === TxpEntitiesState.PermanentError) {
            errorCardDetails = {
                showError: true,
                teeTriggeredError: false,
            };
        }
    }

    return errorCardDetails;
}
